<template>
  <div class="user-manage-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <div class="label">用户类型：</div>
              <el-select
                v-model="filter.role"
                size="small"
                class="select"
                placeholder="请选择"
              >
                <el-option label="全部" :value="-1"></el-option>
                <el-option label="免费用户" :value="0"></el-option>
                <el-option label="会员" :value="1"></el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <div class="label">注册时间：</div>
              <el-date-picker
                v-model="date"
                type="datetimerange"
                align="right"
                unlink-panels
                class="date-input"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                size="small"
              >
              </el-date-picker>
            </div>
            <div class="filter-item">
              <el-input
                class="input"
                type="number"
                v-model="filter.uid"
                style="width: 180px;"
                placeholder="输入用户ID"
                size="small"
              >
              </el-input>
            </div>
            <div class="filter-item">
              <el-input
                class="input"
                type="number"
                v-model="filter.phone"
                style="width: 180px;"
                placeholder="输入注册电话"
                size="small"
              >
              </el-input>
            </div>
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
        </div>
        <div class="btn-box" style="display: flex;justify-content: flex-end;">
          <!-- <button
            class="role-btn"
            @click="addVipModal"
            style="margin-right: 16px"
          >
            + 新建会员
          </button>
          <button class="role-btn" @click="authorizationModal">
            + 开通用户身份
          </button> -->
          <button
            class="role-btn"
            @click="order2excel"
            style="margin-left: 16px;"
          >
            导出
          </button>
        </div>
        <el-table
          :data="userList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="uid" align="center" label="用户ID">
          </el-table-column>
          <el-table-column
            prop="nickname"
            align="center"
            label="用户昵称"
          ></el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            label="注册电话"
          ></el-table-column>
          <el-table-column prop="roleTypeOne" align="center" label="用户类型">
            <div slot-scope="scope">
              {{ roleMap[scope.row.roleTypeOne] || "-" }}
            </div>
          </el-table-column>
          <el-table-column prop="feedMode" align="center" label="喂养方式">
            <div slot-scope="scope">
              <!-- {{ feedModeMap[scope.row.feedMode] || "-" }} -->
              <div v-for="(item, index) in scope.row.babyFeed" :key="index">
                <!-- {{ item.nickname }}： -->
                {{ feedModeMap[item.feedMode] || "-" }}
                <span v-if="item.productName">：</span>
                <span :style="{color: item.isSale ? '#333' : 'red'}" v-if="item.productName">{{ item.productName || "" }}</span>
              </div>
            </div>
          </el-table-column>
          <!-- <el-table-column prop="productName" align="center" label="喂养奶粉">
          </el-table-column> -->
          <!-- <el-table-column prop="feedMode" align="center" label="喂养奶粉">
            <div slot-scope="scope">
              <div v-for="(item, index) in scope.row.babyFeed" :key="index">
                <span :style="{color: item.isSale ? '#333' : 'red'}">{{ item.productName || "" }}</span>
              </div>
            </div>
          </el-table-column> -->
          <el-table-column prop="created" align="center" label="注册时间">
            <div slot-scope="scope">
              {{ scope.row.created | dateFormat }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="320">
            <div
              slot-scope="scope"
              style="display: flex; justify-content: center"
            >
              <div style="display: flex; justify-content: center">
                <button
                  size="mini"
                  class="table-btn"
                  @click="toDetail(scope.row.uid)"
                >
                  查看详情
                </button>
              </div>
              <div style="display: flex; justify-content: center">
                <button
                  size="mini"
                  class="table-btn"
                  @click="toBankCardList(scope.row)"
                >
                  派样记录
                </button>
              </div>
              <!-- <div style="display: flex; justify-content: center">
                <button
                  size="mini"
                  class="table-btn"
                  @click="toRealName(scope.row)"
                >
                  用户画像
                </button>
              </div> -->
              <!-- <div
                style="display: flex; justify-content: center"
                v-if="scope.row.status === 1"
              >
                <button
                  size="mini"
                  class="table-btn"
                  @click="updateStatus(scope.row.uid, 0)"
                >
                  开启
                </button>
              </div> -->
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer" :key="paginationKey">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import JSEncrypt from 'jsencrypt';
import pubKey from '@/assets/js/pubKey.js';
import { staticImg, AREA_OSS } from '@/config'; // oss 图片地址
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'user-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '用户管理'
      },
      filter: {
        // 过滤条件
        phone: '',
        role: -1,
        uid: null,
        start: '',
        end: '',
      },
      userList: [], // 用户列表
      date: [],
      paginationKey: +new Date(),
      showProgressDialog: false,
      progress: 0,
      role: [],
      roleMap: {
        0: '普通用户',
        1: '会员'
      },
      feedModeMap: {
        1: '母乳',
        2: '奶粉喂养',
        3: '母乳+奶粉喂养',
        4: '暂未喂养'
      }
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '--';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== 'userDetail' && from.name !== 'popularize') {
      sessionStorage.setItem('userManage', '');
    }
    next();
  },
  mounted() {
    let data = sessionStorage.getItem('userManage')
      ? JSON.parse(sessionStorage.getItem('userManage'))
      : '';
    if (data) {
      this.filter = {
        ...this.filter,
        ...data.filter
      };
      this.date = data.date;
      this.currentPage = data.currentPage;
      this.paginationKey = +new Date();
      this.setSearchData();
    }
    // 获取列表
    // this.getArea();
    this.getUserList();
    // this.getDictionary();
  },
  computed: {},
  methods: {
    setSearchData() {
      let userManage = {
        currentPage: this.currentPage,
        filter: this.filter,
        date: this.date
      };
      sessionStorage.setItem('userManage', JSON.stringify(userManage));
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getUserList();
    },
    // 获取用户列表
    getUserList() {
      this.filter.start = this.date[0] || '';
      this.filter.end = this.date[1] || '';
      this.setSearchData();
      // return;
      this.loading++;
      this.httpGet(this.$root.getUserList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.userList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      this.getDictionaryByName('role');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 用户详情
    toDetail(uid) {
      this.$router.push({
        name: 'userDetail',
        query: {
          uid
        }
      });
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getUserList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        phone: '',
        // role: -1,
        uid: null,
      };
      this.date = [];
      this.getUserList();
    },
    // handleClose(uid) {
    //   this.$confirm(
    //     `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要关闭该用户身份吗？</p>`,
    //     {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       cancelButtonClass: 'cancel-btn',
    //       confirmButtonClass: 'confirm-btn',
    //       customClass: 'confirm-box',
    //       dangerouslyUseHTMLString: true,
    //       showClose: false,
    //       type: 'none'
    //     }
    //   ).then(() => {
    //     this.loading++;
    //     this.httpPut(this.$root.closeRole, {
    //       uid,
    //       changeType: 1
    //     }).then(
    //       (res) => {
    //         this.$message({
    //           message: '操作成功',
    //           type: 'success'
    //         });
    //         this.loading--;
    //         this.getUserList();
    //       },
    //       (res) => {
    //         this.loading--;
    //         this.$message.error(res);
    //       }
    //     );
    //   });
    // },
    // updateStatus(uid, status) {
    //   let str = '';
    //   if (status === 1) {
    //     str = '封禁';
    //   } else if (status === 0) {
    //     str = '开启';
    //   }
    //   this.$confirm(
    //     `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要${str}该账号吗？</p>`,
    //     {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       cancelButtonClass: 'cancel-btn',
    //       confirmButtonClass: 'confirm-btn',
    //       customClass: 'confirm-box',
    //       dangerouslyUseHTMLString: true,
    //       showClose: false,
    //       type: 'none'
    //     }
    //   ).then(() => {
    //     this.loading++;
    //     this.httpPut(this.$root.updateUserStatus, {
    //       uid,
    //       status
    //     }).then(
    //       (res) => {
    //         this.$message({
    //           message: '操作成功',
    //           type: 'success'
    //         });
    //         this.loading--;
    //         this.getUserList();
    //       },
    //       (res) => {
    //         this.loading--;
    //         this.$message.error(res);
    //       }
    //     );
    //   });
    // },
    async order2excel() {
      // if(!(await this.exportLog())) return;
      this.loading++;
      let userList = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      };
      await this.httpGet(this.$root.getUserList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, userList).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(userList);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          ...this.filter
        };
        await this.httpGet(this.$root.getUserList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        let obj = {
          用户ID: item.uid,
          用户昵称: item.nickname,
          注册电话: item.phone,
          用户类型: this.roleMap[item.roleTypeOne],
          喂养方式: this.feedModeMap[item.feedMode],
          喂养奶粉: item.productName,
          注册时间: item.created,
        };
        formatList.push(obj);
      });
      myUtils.json2excel(formatList);
      // this.exportLog();
    },
    exportLog(){
      this.loading++;
      return this.httpGet(this.$root.getUserList + '/export', {}).then(
        (res) => {
          this.loading--;
          return true;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
          return false;
        }
      );
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.user-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      .role-btn{
        border-radius: 5px;
        background: btn-color;
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
        word(14px, #fff);
        margin-top: 10px;
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 30px;
      }

      .select, .input {
        width: 128px;
      }

      .date-input {
        width: 340px;
      }

      .btn-box {
        margin: 0;
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
  .authorization-form {
    // padding: 16px 0 16px 120px;
    flex-y(flex-start, center);

    .input {
      width: 220px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 15px;
      color: gray9;

      &::placeholder {
        /* WebKit browsers */
        color: #ccc;
      }
    }

    .search-btn {
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }
}
</style>
